import { classNames } from '@/utils';
import Autocomplete from '@superfunnel/ui-core/Autocomplete';

interface Props<T> {
  title?: string;
  selected: T | null;
  getValue: (c: T) => string;
  getOptionId?: (c: T) => string;
  setSelected?: (selected: T | null) => void;
  options: T[];
  className?: string;
}

export default function SettingAutocomplete<T>({
  className,
  title,
  selected,
  getValue,
  getOptionId,
  setSelected,
  options,
}: Props<T>) {
  return (
    <div
      className={classNames(
        'font-inter grid w-full items-center gap-1',
        className,
      )}
    >
      <p className="text-base-700 flex items-center gap-2 text-sm font-medium">
        {title}
      </p>
      <div className="mt-1 flex flex-wrap items-start justify-between gap-2 gap-x-6 sm:mt-0 sm:flex-auto">
        <Autocomplete
          getValue={getValue}
          selected={selected || undefined}
          onChange={(s) => setSelected?.(s)}
          getOptionId={getOptionId}
          options={options}
        />
      </div>
    </div>
  );
}
